// src/services/CommunicationService.js
import ActionTypes from './enums/ActionTypes';

class CommunicationService {
  constructor() {
    this.pendingRequests = {}; // Store requests awaiting responses
    this.messageId = 0; // Unique ID for each request
    this.initialData = null; // Store initial data
    this.initialDataPromise = new Promise((resolve) => {
      this.resolveInitialData = resolve;
    });

    // Listen for messages from the parent page
    window.addEventListener('message', this.handleMessage.bind(this));
  }

  // Handle incoming messages from the parent page
  handleMessage(event) {
    // if (event.origin !== 'http://127.0.0.1:5500') return; // Adjust to the parent page's origin

    const { action, messageId, data } = event.data;

    // Handle initial data
    if (action === ActionTypes.INITIAL_DATA) {
      this.initialData = data;
      this.resolveInitialData(this.initialData);
    }

    // Handle responses to specific data requests
    if (action === ActionTypes.RESPONSE_DATA && messageId in this.pendingRequests) {
      this.pendingRequests[messageId].resolve(data);
      delete this.pendingRequests[messageId];
    }
  }

  // Request additional data asynchronously
  requestData(requestData) {
    return new Promise((resolve, reject) => {
      const messageId = this.generateMessageId();
      this.pendingRequests[messageId] = { resolve, reject };

      window.parent.postMessage(
        { action: ActionTypes.REQUEST_DATA, messageId, data: requestData },
        '*'
      );
    });
  }

  // Send data to the parent page
  sendDataToParent(data) {
    window.parent.postMessage(
      { action: ActionTypes.SAVE_DATA, data },
      '*'
    );
  }

  // Send trigger to the parent page
  sendTriggerToParent(data) {
    window.parent.postMessage(
      { action: ActionTypes.TRIGGER_DATA, data },
      '*'
    );
  }

  // Generate a unique message ID
  generateMessageId() {
    return ++this.messageId;
  }

  // Get initial data when ready
  getInitialData() {
    return this.initialDataPromise;
  }
}

const communicationService = new CommunicationService();
export default communicationService;
